<ng-container *transloco="let convert;">
  <div class="reply__inner replyForm">
    <div class="reply__text-area d-flex flex-column app-textarea">
      <div class="form-group mb-0">
        <label class="d-block text-start" for="accept-offer-comment">{{convert('sellModule.question.questionDrawer.reply.labelYourResponse')}}</label>
        <textarea
          [attr.aria-label]="convert('sellModule.question.questionDrawer.reply.ariaLabelReplyToBuyer')"
          id="accept-offer-comment"
          [class]="questionError ? 'form-control mb-1 question-text-area' : 'form-control mb-1'"
          rows="3"
          maxlength="150"
          appCharacterCount
          #comment="appCharacterCount"
          (input)="setAnswerValue($event.target.value)"
        ></textarea>
        <app-character-count
          [count]="comment.count$ | async"
          [maxLength]="150"
          [characterCountTranslate]="characterCountData">
        </app-character-count>
      </div>
      @if (questionError) {
        <span class="question-error-style" tabindex="0" role="alert">{{ questionError }}</span>
      }
    </div>

    <div class="reply__action-btns d-flex flex-column flex-lg-row lg-justify-content-start">
      <button
        class="btn btn-primary"
        type="submit"
        data-track-elem="button"
        data-track-name="Submit"
        [attr.aria-label]="convert('sellModule.question.questionDrawer.reply.ariaLabelSubmitAnswer')"
        (click)="submitAnswer()"
        >
        {{convert('common.labelSubmit')}}
      </button>

      <button
        class="ms-lg-2 mt-2 mt-lg-0 btn btn btn-outline-primary"
        type="button"
        data-track-elem="button"
        data-track-name="Cancel"
        data-track-trigger="close"
        [attr.aria-label]="convert('sellModule.question.questionDrawer.reply.ariaLabelCancelReply')"
        (click)="cancel()"
        >
        <span>{{convert('common.btnCancel')}}</span>
      </button>
    </div>
  </div>
</ng-container>
